var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 22",
    style: {
      enableBackground: "new 0 0 16 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,8.9C15,8.3,14.4,8,13.8,8h-3.6l1.2-6c0-0.1,0-0.3,0-0.4c0-0.9-0.7-1.6-1.6-1.6H9.7H9.6 C9.3,0,9.1,0.1,8.9,0.3C8.8,0.4,8.7,0.5,8.6,0.6L8.5,0.7l-7.6,9.9c-0.4,0.5-0.4,1.1-0.1,1.7c0.3,0.5,0.8,0.9,1.4,0.9h3.6l-1.2,6.9 c-0.1,0.7,0.3,1.5,1,1.8C5.8,22,6,22,6.2,22c0.5,0,0.9-0.2,1.2-0.7L15,10.5C15.5,10,15.5,9.4,15.3,8.9z M13.3,9.8l-6.7,9.5L8,11.4 H2.6l6.6-8.7L7.9,9.8H13.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices2);
export default __webpack_public_path__ + "static/media/services2.bf70c42d676688695c7e8044d06ae426.svg";
export { ForwardRef as ReactComponent };